import { RicosPluginToolbarNames } from "./../ricos-types";
import { DEFAULTS } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import { InsertModal } from "./modals/InsertModal";
import { SettingsModal } from "./modals/SettingsModal";
import { tiptapExtensions } from "./tiptap/tiptap";
import { VIDEO_TYPE } from "./types";
import { videoConverter } from "./video-converter";
const pluginVideo = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: VIDEO_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [videoConverter],
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [RicosPluginToolbarNames.VIDEO],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    __exports: { SettingsModal, InsertModal }
  };
};
export {
  pluginVideo
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
